/*------------------------------------------------
// File Name:PDM_BANNER.js
// File Description:PDM_BANNER store方法
// Author:zxl
// Create Time:2022/08/30 15:17:48
//------------------------------------------------*/

import {
    GetPDM_BANNERList,
    GetPDM_BANNERListByPage,
    GetPDM_BANNEREntity,
    CreatePDM_BANNEREntity,
    UpdatePDM_BANNEREntity,
    DeletePDM_BANNEREntity,
} from '@/api/pdm/banner'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmBanner = {
    namespaced: true,
    state: {
        PdmBannerList: [],
        PdmBannerListLoading: false,
        PdmBannerEntity: null,
        PdmBannerShowDlg: false,
    },
    mutations: {
        setPdmBannerList(state, dataList) {
            state.PdmBannerList = [...dataList]
        },
        setPdmBannerListLoading(state, visible) {
            state.PdmBannerListLoading = visible
        },
        setPdmBannerShowDlg(state, visible) {
            state.PdmBannerShowDlg = visible
        },
        setPdmBannerEntity(state, entity) {
            state.PdmBannerEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreatePdmBanner({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_BANNEREntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBannerEntity', res.Data)
                        commit('setPdmBannerShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetPdmBannerEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBannerListLoading', true)
                GetPDM_BANNEREntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBannerEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBannerListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetPdmBannerList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBannerListLoading', true)
                GetPDM_BANNERList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBannerList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBannerListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetPdmBannerListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmBannerListLoading', true)
                GetPDM_BANNERListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBannerList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmBannerListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdatePdmBanner({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_BANNEREntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmBannerShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BANNER
        actEditPdmBannerData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmBannerID : entity.PdmBannerID
                }
                GetPDM_BANNEREntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmBannerEntity', res.Data)
                        commit('setPdmBannerShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_BANNER ,传对象过来
        actEditPdmBanner({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmBannerEntity', entity)
                commit('setPdmBannerShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_BANNER
        actDeletePdmBanner({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeletePDM_BANNEREntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmBannerShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


